import React from 'react';

const FinanceDepositsCard = ({ confirmed, pending }) => (
  <>
    <p className="mt-1 text-[30px] font-semibold leading-tight tracking-[-0.9px] text-emerald-800">
      {confirmed.toLocaleString('fr-FR')} <span className="text-xs font-normal tracking-normal">F CFA</span>
    </p>
    <p className="mt-1 text-[13px] text-slate-500">Montant soldé</p>
    <div className="mt-[18px] border-t pt-3">
      <p className="text-[13px] text-slate-500">Paiements en attente</p>
      <p className="mt-1 text-base font-semibold">{pending.toLocaleString('fr-FR')} F CFA</p>
    </div>
  </>
);
export default FinanceDepositsCard;
